// extracted by mini-css-extract-plugin
export var linkText = "_nz-0";